import { detailsSlots } from '@/shared/details'
import type { AdminHomeLink, FeatureRoute, SlotContribution } from '@/shared/registry'

import { userDetailsSlot, userFormTabsSlot } from '../users/user'
import {
  createUserCustomFieldPath,
  editUserCustomFieldRoute,
  readUserCustomFieldsPermission,
  userCustomFieldRoute,
  userCustomFieldsPath,
  writeUserCustomFieldsPermission,
} from './paths'

/** Find Custom Fields, Custom Field Details, and Create and Edit Custom Field for people (SM-20). */
export const userCustomFieldRoutes: readonly FeatureRoute[] = [
  {
    path: userCustomFieldsPath,
    titleId: 'siteManagement.customFields.find.title',
    page: () => import('./FindUserCustomFieldsPage').then((module) => module.FindUserCustomFieldsPage),
  },
  {
    path: createUserCustomFieldPath,
    titleId: 'siteManagement.customFields.create.title',
    page: () => import('./UserCustomFieldFormPages').then((module) => module.CreateUserCustomFieldPage),
  },
  {
    path: userCustomFieldRoute,
    titleId: 'siteManagement.customFields.details.title',
    page: () => import('./UserCustomFieldDetailsPage').then((module) => module.UserCustomFieldDetailsPage),
  },
  {
    path: editUserCustomFieldRoute,
    titleId: 'siteManagement.customFields.edit.title',
    page: () => import('./UserCustomFieldFormPages').then((module) => module.EditUserCustomFieldPage),
  },
]

/** Find and Create Custom Field on Admin Home, under Users, as the mockups' "User Custom Fields". */
export const userCustomFieldAdminHomeLinks: readonly AdminHomeLink[] = [
  { id: 'find-user-custom-fields', category: 'users', labelId: 'siteManagement.customFields.find.title', path: userCustomFieldsPath, permission: readUserCustomFieldsPermission },
  { id: 'create-user-custom-field', category: 'users', labelId: 'siteManagement.customFields.create.title', path: createUserCustomFieldPath, permission: writeUserCustomFieldsPermission },
]

/** The Custom Fields tab on User Details, and on Create and Edit User, saved with the form. */
export const userCustomFieldSlots: readonly SlotContribution[] = [
  {
    kind: 'tab',
    slot: detailsSlots(userDetailsSlot).tabs,
    id: 'custom-fields',
    labelId: 'siteManagement.customFields.userTab.label',
    component: () => import('./UserCustomFieldsDetailsTab').then((module) => module.UserCustomFieldsDetailsTab),
  },
  {
    kind: 'tab',
    slot: userFormTabsSlot,
    id: 'custom-fields',
    labelId: 'siteManagement.customFields.userTab.label',
    component: () => import('./UserCustomFieldsFormTab').then((module) => module.UserCustomFieldsFormTab),
  },
]
